import api from "@/router/api";

export default {
  // Tarefas
  async getAllTarefas(page, size, returnNumPag) {
    const response = await api.get("/tarefa", {
      params: {
        page,
        size,
      },
    });

    if (returnNumPag) {
      return {
        tarefa: response.data?.content ?? response.data ?? [],
        numPag: response.data?.totalPages ?? 1,
      };
    }
    return response.data?.content ?? response.data ?? [];
  },

  async transitarEstadoTarefa(tarefaId) {
    const response = await api.put(`/tarefa/transitar-estado/${tarefaId}`);
    return response.data;
  },

  async getTarefaById(tarefaId) {
    const response = await api.get(`/tarefa/${tarefaId}`);
    return response.data;
  },

  async getTarefasByAcao(page, size, acaoId, returnNumPag) {
    const response = await api.get(`/tarefa/acao/${acaoId}`, {
      params: {
        page,
        size,
      },
    });

    if (returnNumPag) {
      return {
        tarefa: response.data?.content ?? response.data ?? [],
        totalPages: response.data?.totalPages ?? 1,
      };
    }
    return response.data?.content ?? response.data ?? [];
  },

  async postTarefa(tarefa, operacao) {
    const response = await api.post("/tarefa", tarefa, {
      params: { operacao },
    });
    return response.data || response;
  },

  async putTarefa(tarefaId, operacao, tarefa) {
    const response = await api.put(`/tarefa/${tarefaId}`, tarefa, {
      params: { operacao },
    });
    return response.data || response;
  },

  async deleteTarefa(tarefaId) {
    const response = await api.delete(`/tarefa/excluir/${tarefaId}`);
    return response.data;
  },

  async cancelarTarefa(tarefaId) {
    const response = await api.get(`/tarefa/cancelar/${tarefaId}`);
    return response.data || response;
  },

  async alocarTarefa(tarefaId, membrosTime) {
    const response = await api.post(`/tarefa/alocar/${tarefaId}`, {
      membrosTimeId: membrosTime,
    });
    return response.data || response;
  },

  async desalocarMembroTarefa(tarefaId, membros) {
    const response = await api.put(
      `/tarefa/desalocar-membro/${tarefaId}`,
      membros
    );
    return response.data || response;
  },

  // Estado da tarefa
  async getEstadoTarefa() {
    const response = await api.get("/estado-tarefa");
    return response.data;
  },

  async getEstadoTarefaById(estadoTarefaId) {
    const response = await api.get(`/estado-tarefa/${estadoTarefaId}`);
    return response.data;
  },

  async getEstadoTarefaByNome(nome) {
    const response = await api.get("/estado-tarefa/buscar", {
      params: { nome },
    });
    return response.data;
  },

  async postEstadoTarefa(estadoTarefa) {
    const response = await api.post("/estado-tarefa", estadoTarefa);
    return response.data;
  },

  // Prioridade tarefa
  async getPrioridadeTarefa() {
    const response = await api.get("/prioridade-tarefa");
    return response.data;
  },

  async getPrioridadeTarefaById(prioridadeTarefaId) {
    const response = await api.get(`/prioridade-tarefa/${prioridadeTarefaId}`);
    return response.data;
  },

  async getPrioridadeTarefaByNome(nome) {
    const response = await api.get("/prioridade-tarefa/busca", {
      params: { nome },
    });
    return response.data;
  },

  async postPrioridadeTarefa(prioridadeTarefa) {
    const response = await api.post("/prioridade-tarefa", prioridadeTarefa);
    return response.data;
  },

  // Status Tarefa
  async getStatusTarefa() {
    const response = await api.get("/status-tarefa");
    return response.data;
  },

  async getStatusTarefaById(statusTarefaId) {
    const response = await api.get(`/status-tarefa/${statusTarefaId}`);
    return response.data;
  },

  async concluirSubTarefa(id) {
    const response = await api.put(`/subtarefas/${id}/concluir`, {
      percentualConclusao: 100,
    });
    return response.data;
  },

  async getStatusTarefaByNome(nome) {
    const response = await api.get("/status-tarefa/busca", {
      params: { nome },
    });
    return response.data;
  },

  async postStatusTarefa(statusTarefa) {
    const response = await api.post("/status-tarefa", statusTarefa);
    return response.data;
  },

  async getFiltroTarefas(acaoId, filtroPrincipal, filtroStatus, page, size) {
    const response = await api.get(`/tarefa/acao/${acaoId}/visualizar`, {
      params: {
        filtroPrincipal,
        filtroStatus,
        page,
        size,
      },
    });
    return response.data.content || response.data;
  },

  async voluntariarTarefa(tarefaId) {
    const response = await api.post("/tarefa/voluntariar", {
      tarefasId: [tarefaId],
    });
    return response.data || response;
  },

  async putPorcentagemTarefa(tarefaId, porcentagem) {
    const response = await api.put(`/tarefa/percentual/${tarefaId}`, {
      percentualConclusao: porcentagem,
    });
    return response.data || response;
  },

  // Subtarefas
  async postSubTarefa(dados) {
    const response = await api.post("/subtarefas", {
      titulo: dados.titulo,
      dataInicio: dados.dataInicio,
      dataFim: dados.dataFim,
      tarefaId: dados.tarefaId,
    });
    return response.data || response;
  },

  async getSubTarefas(page, size, tarefaId) {
    const response = await api.get(`/subtarefas/por-tarefa/${tarefaId}`, {
      params: {
        page,
        size,
      },
    });
    return response.data || response;
  },

  async deleteSubTarefa(subTarefaId) {
    const response = await api.delete(`/subtarefas/${subTarefaId}`);
    return response.data || response;
  },

  async putSubTarefa(tarefaId, subtarefaId, dados) {
    const response = await api.put(`/subtarefas/${subtarefaId}`, {
      tarefaId,
      titulo: dados.titulo,
      dataInicio: dados.dataInicio,
      dataFim: dados.dataFim,
    });
    return response.data || response;
  },
};
